export default "__VITE_ASSET__DisIJ0l$__"